import { useSearchParams } from 'react-router-dom'
import PosAccountsItem from 'views/PosAccounts/Item'
import EditPosAccount from 'views/PosAccounts/EditPosAccount'

import { IPosAccountWithRoles } from 'types/posAccounts'
type TProps = {
  posAccounts: IPosAccountWithRoles[] | undefined
}

const PosAccountsList = ({ posAccounts }: TProps) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const uuid = searchParams?.get('uuid') ?? ''

  const onClickItem = (uuid: string) => {
    searchParams.set('uuid', uuid)
    setSearchParams(searchParams)
  }

  const onClose = () => {
    searchParams.set('uuid', '')
    setSearchParams(searchParams)
  }

  return (
    <>
      <div className="item-list">
        {posAccounts?.map(({ name, phone, email, pinNumber, deactivatedAt, uuid, id, roles }) => (
          <PosAccountsItem
            name={name}
            phone={phone}
            email={email}
            pinNumber={pinNumber}
            deactivatedAt={deactivatedAt}
            key={uuid}
            id={id}
            roles={roles}
            uuid={uuid}
            onClickItem={onClickItem}
          />
        ))}
      </div>
      {uuid && <EditPosAccount onClose={onClose} uuid={uuid} />}
    </>
  )
}

export default PosAccountsList
